var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 49,
    viewBox: "0 0 64 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8516 39H0.539062V9.89844H10.9297C13.8594 9.89844 16.3789 10.4844 18.4883 11.6562C20.5977 12.8151 22.2188 14.4818 23.3516 16.6562C24.4974 18.8177 25.0703 21.4089 25.0703 24.4297C25.0703 27.4635 24.4974 30.0677 23.3516 32.2422C22.2188 34.4167 20.5911 36.0898 18.4688 37.2617C16.3464 38.4206 13.8073 39 10.8516 39ZM6.67188 33.7266H10.5781C13.3255 33.7266 15.4089 32.9909 16.8281 31.5195C18.2474 30.0482 18.957 27.6849 18.957 24.4297C18.957 21.2005 18.2474 18.8503 16.8281 17.3789C15.4089 15.9076 13.3255 15.1719 10.5781 15.1719H6.67188V33.7266ZM37.4336 0.523438V48.375H31.7109V0.523438H37.4336ZM44.6016 39V9.89844H50.7344V33.9219H63.2148V39H44.6016Z",
    fill: "#125BAE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.58edf269a2c35d29e1c7bc91cfbae471.svg";
export { ForwardRef as ReactComponent };